var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0A84FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.5C14.4233 26.5 12.3932 25.8842 10.6665 24.7304C8.9398 23.5767 7.59399 21.9368 6.79927 20.0182C6.00455 18.0996 5.79661 15.9884 6.20176 13.9516C6.6069 11.9148 7.60693 10.0438 9.07538 8.57538C10.5438 7.10693 12.4148 6.1069 14.4516 5.70176C16.4884 5.29661 18.5996 5.50455 20.5182 6.29927C22.4368 7.09399 24.0767 8.4398 25.2304 10.1665C26.3842 11.8932 27 13.9233 27 16C27 18.7848 25.8938 21.4555 23.9246 23.4246C21.9555 25.3938 19.2848 26.5 16.5 26.5ZM16.5 7C14.72 7 12.9799 7.52785 11.4999 8.51678C10.0198 9.50571 8.86628 10.9113 8.18509 12.5559C7.5039 14.2004 7.32567 16.01 7.67294 17.7558C8.0202 19.5016 8.87737 21.1053 10.136 22.364C11.3947 23.6226 12.9984 24.4798 14.7442 24.8271C16.49 25.1743 18.2996 24.9961 19.9442 24.3149C21.5887 23.6337 22.9943 22.4802 23.9832 21.0001C24.9722 19.5201 25.5 17.78 25.5 16C25.5 13.6131 24.5518 11.3239 22.864 9.63604C21.1761 7.94822 18.887 7 16.5 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9425 20.5L15.75 16.3075V9.25H17.25V15.685L21 19.4425L19.9425 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDevices);
export default __webpack_public_path__ + "static/media/TotalDevices.b6d5870c15bb1d3cf16fd3080c2e79bb.svg";
export { ForwardRef as ReactComponent };